export default __webpack_public_path__ + "static/media/step1.38861d0e.png";